/** Tipos das Etapas dos Funis de Vendas */
export interface FunilVendaEtapaTipo {
    id: number;
    nome: string;
}

export const funilVendaEtapaTipoLead: FunilVendaEtapaTipo = {id: 1, nome: 'Lead'};
export const funilVendaEtapaTipoQualificado: FunilVendaEtapaTipo = {id: 2, nome: 'Qualificado'};
export const funilVendaEtapaTipoDesqualificado: FunilVendaEtapaTipo = {id: 3, nome: 'Desqualificado'};
export const funilVendaEtapaTipoOportunidade: FunilVendaEtapaTipo = {id: 4, nome: 'Oportunidade'};
export const funilVendaEtapaTipoGanho: FunilVendaEtapaTipo = {id: 5, nome: 'Ganho'};
export const funilVendaEtapaTipoCongelado: FunilVendaEtapaTipo = {id: 6, nome: 'Congelado'};
export const funilVendaEtapaTipoPerdido: FunilVendaEtapaTipo = {id: 7, nome: 'Perdido'};
export const funilVendaEtapaTipoPersonalizada: FunilVendaEtapaTipo = {id: 99, nome: 'Personalizada'};

export const funilVendaEtapaTipos: FunilVendaEtapaTipo[] = [
    funilVendaEtapaTipoLead,
    funilVendaEtapaTipoQualificado,
    funilVendaEtapaTipoDesqualificado,
    funilVendaEtapaTipoOportunidade,
    funilVendaEtapaTipoGanho,
    funilVendaEtapaTipoCongelado,
    funilVendaEtapaTipoPerdido,
    funilVendaEtapaTipoPersonalizada
];

/** Verifica se a Etapa do Funil de Vendas é do tipo Lead */
export function isFunilVendaEtapaTipoLead(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoLead.id;
}

/** Verifica se a Etapa do Funil de Vendas é do tipo Qualificado */
export function isFunilVendaEtapaTipoQualificado(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoQualificado.id;
}

/** Verifica se a Etapa do Funil de Vendas é do tipo Desqualificado */
export function isFunilVendaEtapaTipoDesqualificado(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoDesqualificado.id;
}

/** Verifica se a Etapa do Funil de Vendas é do tipo Oportunidade */
export function isFunilVendaEtapaTipoOportunidade(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoOportunidade.id;
}

/** Verifica se a Etapa do Funil de Vendas é do tipo Ganho */
export function isFunilVendaEtapaTipoGanho(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoGanho.id;
}

/** Verifica se a Etapa do Funil de Vendas é do tipo Congelado */
export function isFunilVendaEtapaTipoCongelado(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoCongelado.id;
}


/** Verifica se a Etapa do Funil de Vendas é do tipo Perdido */
export function isFunilVendaEtapaTipoPerdido(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoPerdido.id;
}

/** Verifica se a Etapa do Funil de Vendas é do tipo Personalizada */
export function isFunilVendaEtapaTipoPersonalizada(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaEtapaTipoPersonalizada.id;
}
